































// Vue
import { defineComponent } from '@vue/composition-api'

// components
import { Select2 } from '@/components/general'

// utils
import { dateLibs } from '@/utils'

export default defineComponent({
  name: 'FiltersWorkSheetMonthly',
  components: {
    Select2
  },
  props: {
    filters: {
      type: Object,
      required: true
    }
  },
  setup () {
    const years = dateLibs.createRangeYears()
    const months = dateLibs.getAllMonths()
    const fortnights = dateLibs.fortnightsDefault

    return {
      years,
      months,
      fortnights
    }
  }
})
